// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-FooterConfirm-styles___footerConfirm--Ca_q4 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  background: #ffffff;
  box-shadow: 0 -2px 4px 0 rgba(109, 113, 122, 0.15);
  border: 2px solid #e0e2e6;
  padding: 40px;
  padding-bottom: 24px;
  padding-top: 24px;
  position: fixed;
  bottom: 0;
  width: calc(100% - 240px);
  margin-left: 0;
  right: 0;
}

  .components-FooterConfirm-styles___footerConfirm--Ca_q4 .components-FooterConfirm-styles___footerText--usXHb {
    font-family: 'Roboto';
    font-size: 21px;
    color: #1b2432;
    letter-spacing: 0;
    font-weight: 600;
    text-align: left;
  }

  .components-FooterConfirm-styles___footerConfirm--Ca_q4 .components-FooterConfirm-styles___footerText--usXHb .components-FooterConfirm-styles___secondaryText--lj8Hz {
      font-size: 15px;
      font-weight: 500;
      color: #757982;
      padding: 4px 0 0;
    }

  .components-FooterConfirm-styles___footerConfirm--Ca_q4 .components-FooterConfirm-styles___buttonContainer--wo4om {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .components-FooterConfirm-styles___footerConfirm--Ca_q4 .components-FooterConfirm-styles___buttonContainer--wo4om button:first-of-type {
      margin-right: 15px;
    }

  .components-FooterConfirm-styles___footerConfirm--Ca_q4 .components-FooterConfirm-styles___buttonContainer--wo4om .components-FooterConfirm-styles___button--U7lg4 {
      width: 189px !important;
      height: 53px !important;
      display: flex;
      justify-content: center;
      align-items: center;
    }
`, "",{"version":3,"sources":["webpack://./components/FooterConfirm/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,QAAQ;AAmCV;;EAjCE;IACE,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAQlB;;EANE;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,gBAAgB;IAClB;;EAGF;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EAarB;;EAXE;MACE,kBAAkB;IACpB;;EAEA;MACE,uBAAuB;MACvB,uBAAuB;MACvB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB","sourcesContent":[".footerConfirm {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100px;\n  background: #ffffff;\n  box-shadow: 0 -2px 4px 0 rgba(109, 113, 122, 0.15);\n  border: 2px solid #e0e2e6;\n  padding: 40px;\n  padding-bottom: 24px;\n  padding-top: 24px;\n  position: fixed;\n  bottom: 0;\n  width: calc(100% - 240px);\n  margin-left: 0;\n  right: 0;\n\n  .footerText {\n    font-family: 'Roboto';\n    font-size: 21px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-weight: 600;\n    text-align: left;\n\n    .secondaryText {\n      font-size: 15px;\n      font-weight: 500;\n      color: #757982;\n      padding: 4px 0 0;\n    }\n  }\n\n  .buttonContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    button:first-of-type {\n      margin-right: 15px;\n    }\n\n    .button {\n      width: 189px !important;\n      height: 53px !important;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerConfirm": `components-FooterConfirm-styles___footerConfirm--Ca_q4`,
	"footerText": `components-FooterConfirm-styles___footerText--usXHb`,
	"secondaryText": `components-FooterConfirm-styles___secondaryText--lj8Hz`,
	"buttonContainer": `components-FooterConfirm-styles___buttonContainer--wo4om`,
	"button": `components-FooterConfirm-styles___button--U7lg4`
};
module.exports = ___CSS_LOADER_EXPORT___;
